import {useState} from "react";

export default function AboutUs() {

    const [activeImageUrl, setstate] = useState(null)
    const TitlePart = ({ children }) => {
      return <h1 className="hardfile-title">{children}</h1>;
    };
    const ContentPart = ({ children }) => {
      return <p className="hardfile-text font-nsjp font-normal">{children}</p>;
    };
    const ContentPartbBold = ({ children }) => {
      return <p className="font-nsjp font-bold">{children}</p>;
    };
    const ContentPartbBoldNested = ({ children }) => {
      return <span className="font-nsjp font-bold">{children}</span>;
    };
    const PartContainer = ({ children }) => {
      return <div className="aboutUs-part-container">{children}</div>;
    };
    const ImageAboutUs = ({url, alt}) => {
        return <img onClick={() => {
        }} className="aboutUs-image" src={url} alt={alt}/>
    };
    return (
      <div className="mb-32">
        <PartContainer>
          <TitlePart>{"La télévision locale de Troyes et de l’Aube"}</TitlePart>
          <ContentPart>
            {`220 000 téléspectateurs potentiels en TNT (numéro 32) , 
                  une présence sur toutes les Box TV (chaîne 30) dans toute l'Aube, 
                  mais aussi partout en France.`}
          </ContentPart>
          <ContentPart>{"Effectif : 17 salariés"}</ContentPart>
          <ContentPartbBold>
            {
              "N°1 des télévisions locales en France sur 3 critères : audience cumulée, notoriété et DET (durée d'écoute par téléspectateur)."
            }
          </ContentPartbBold>
        </PartContainer>
        <PartContainer>
          <TitlePart>{"Que faisons nous ?"}</TitlePart>
          <ContentPart>
            <ContentPartbBoldNested>Deux heures</ContentPartbBoldNested> de
            programmes frais chaque jour (rediffusion en boucle 24h/24).
          </ContentPart>
          <ContentPart>
            Un{" "}
            <ContentPartbBoldNested>journal d’information</ContentPartbBoldNested>{" "}
            locale en direct à 18h30 suivi de la météo.
          </ContentPart>
          <ContentPart>
            Des émissions en{" "}
            <ContentPartbBoldNested>direct</ContentPartbBoldNested> tous les soirs
            de 19h à 20h (société, culture, économie, sport, etc).
          </ContentPart>
        </PartContainer>
        <PartContainer>
          <TitlePart>
            {
              "Des magazines axés sur la culture, le sport, l'économie, la vie associative…"
            }
          </TitlePart>
          <ContentPart>
            Canal 32 a chaque jour l’ambition d’être un{" "}
            <ContentPartbBoldNested>média de proximité.</ContentPartbBoldNested>
          </ContentPart>
          <ContentPart>
            {`Ainsi, la chaîne rend compte de la vie économique (à travers 
          le mag Réussites, avec la CCI,  le mag agricole " Terres de l'Aube", 
          avec la Chambre d'Agriculture, ou bien Question Santé, avec la CPAM).`}
          </ContentPart>
          <ContentPart>
            Canal 32 propose aussi des{" "}
            <ContentPartbBoldNested>émissions culturelles</ContentPartbBoldNested>{" "}
            comme « Envie de Sortir ». Elle suit{" "}
            <ContentPartbBoldNested>l’actualité sportive</ContentPartbBoldNested>{" "}
            avec le « JT sports » ou « Club Estac » ou l'actualité des 15-25 ans,
            avec " Génération Y".
          </ContentPart>
        </PartContainer>
        <div className="aboutUs-container-image">
        <ImageAboutUs url="images/aboutUs/vivez-info-c32.jpg" alt="image vivez l'info dans l'aube"/>
        <ImageAboutUs url="images/aboutUs/pub-app-C32.png" alt="image pub Canal 32"/>
        <ImageAboutUs url="images/aboutUs/plateau-lejt.jpg" alt="image plate de l'émission le JT de Canal 32"/>
        </div>
      </div>
    );
  }
  